<template>
  <div class="EnvironmentalMonitor">
    <div class="EnvironmentalMonitor__Header">
      <div class="title">
        环境监测（实时数据）
      </div>
      <div class="deviceName">
        {{ deviceItem.deviceAlias }}
      </div>
    </div>
    <el-carousel
      v-if="visi"
      :interval="element.style.interval"
      arrow="never"
      @change="change"
    >
      <el-carousel-item
        v-for="item in list"
        :key="item.ycjzDeviceId"
      >
        <div class="list">
          <div
            class="item"
            :class="{warn:item.tspWarn==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/tsp.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >TSP(ug/m³)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.tsp }}</div>
          </div>
          <div
            class="item"
            :class="{warn:item.pm10Warn==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/pm10.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >PM10(ug/m³)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.pm10 }}</div>
          </div>
          <div
            class="item"
            :class="{warn:item.pm25Warn==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/pm2.5.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >Pm2.5(ug/m³)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.pm25 }}</div>
          </div>
          <div
            class="item"
            :class="{warn:item.noiseWarn==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/db.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >噪音(dB(A))</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.noise }}</div>
          </div>
          <div
            class="item"
            :class="{warn:item.temperatureWarn==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/temperature.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >温度(°C)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.temperature }}</div>
          </div>
          <div class="item">
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/wet.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >湿度(%)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.humidity }}</div>
          </div>
          <div
            class="item"
            :class="{warn:item.windSpeedWarn==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/windSpeed.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >风速(m/s)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.windSpeed }}</div>
          </div>
          <div
            class="item"
            :class="{warn:item.windLvWarn==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/windPower.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >风力(级)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.windLv }}</div>
          </div>
          <div
            class="item"
            :class="{warn:item.barometric==1}"
          >
            <div class="icon"><img
              src="../../../../../../../assets/images/custom-screen/kpa.png"
              alt=""
            /></div>
            <div
              class="unit"
              :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
            >气压(KPa)</div>
            <div
              class="num"
              :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
            >{{ item.barometric }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { siteYcjzDeviceList } from '@/api/device'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
export default {
  props: {
    propValue: {
      type: String,
      default: ''
    },
    areaIdList: {
      type: [String, Array],
      default: ''
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      keyName: {
        tsp: { label: 'TSP', title: 'TSP(ug/m³)' },
        pm10: { label: 'PM10', title: 'PM10(ug/m³)' },
        pm25: { label: 'PM2.5', title: 'PM2.5(ug/m³)' },
        noise: { label: '噪音', title: '噪音(dB（A）)' },
        temperature: { label: '温度', title: '温度(°C)' },
        humidity: { label: '湿度', title: '湿度(%rh)' },
        wind_speed: { label: '风速', title: '风速(m/s)' },
        wind_lv: { label: '风力', title: '风力(级)' },
        qiya: { label: '气压', title: '气压(KPa)' }
      },
      deviceItem: {},
      visi: true
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },
  watch: {
    'element.style.interval': {
      deep: true,
      handler(val) {
        this.visi = false
        this.$nextTick(() => {
          this.visi = true
        })
      }
    }
  },
  created() {
    this.getData()
  },

  methods: {
    changeDevicePixelRatio,
    getData() {
      siteYcjzDeviceList({
        projectId: this.projectItem.projectId,
        pageSize: 9999,
        pageNumber: 1
      }).then((res) => {
        this.deviceItem = res.data.records[0]
        this.list = res.data.records
      })
    },
    change(index) {
      this.deviceItem = this.list[index]
    }
  }
}
</script>

<style lang="scss" scoped>
.EnvironmentalMonitor {
  width: 100%;
  height: 100%;
  position: relative;
  &__Header {
    color: #00cbfe;
    padding: 3%;
    display: flex;
    justify-content: space-between;
    font-size: 4px;
    .title {
      font-weight: bold;
      font-size: 4px;
    }
    .deviceName {
      font-weight: bold;
      font-size: 4px;
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      width: 30%;
      border: 1px solid #0240ae;
      border-radius: 6px;
      text-align: center;
      color: #fff;
      margin-bottom: 3%;
      padding-top: 3%;
      .icon {
        width: 60%;
        // background: #fff;
        margin: 0 auto;
        img {
          width: 100%;
          display: block;
        }
      }
      .unit {
        margin-top: 5%;
      }
      .num {
        font-size: 18px;
        font-weight: bold;
        padding: 4% 0;
      }
    }
    .warn {
      color: #d9040c;
    }
  }
}
.el-carousel {
  height: 100%;
}
</style>
<style >
.EnvironmentalMonitor .el-carousel__container {
  height: 100%;
}
</style>
